import React from 'react';
import PropTypes from 'prop-types';

import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { TextBody } from 'web-ui-components/lib/atoms/text';
import { SectionHeading } from 'web-ui-components/lib/molecules/text';

import { CommonShell } from '../common/CommonShell/CommonShell';

const GenericErrorPage = ({ routeTo, content, retry }) => {
  const { alerts, errorInfo, retryBtn } = content;
  return (
    <CommonShell
      backClick={() => {
        routeTo('/exit');
      }}
    >
      <SectionHeading heading2={alerts}></SectionHeading>
      <TextBody>
        <p>{errorInfo}</p>
      </TextBody>
      <NavigationButton.Primary labelText={retryBtn} onClick={retry} />
    </CommonShell>
  );
};

GenericErrorPage.propTypes = {
  content: PropTypes.object,
  routeTo: PropTypes.func,
  retry: PropTypes.func,
};

export default GenericErrorPage;
